export const headers = [
  {
    order: true,
    key: 'first_name',
    i18n: 'USER_NAME_KEY',
  },
  {
    order: true,
    key: 'email',
    i18n: 'Email',
  },
  {
    order: true,
    key: 'client_name',
    i18n: 'CLIENT_KEY',
  },
  {
    order: true,
    key: 'environment_name',
    i18n: 'ENVIRONMENT_KEY',
  },
  {
    order: true,
    key: 'partner_name',
    i18n: 'PARTNER_KEY',
  },
  {
    order: true,
    key: 'request_uuid',
    i18n: 'REQUEST_ID_KEY',
  },
  {
    order: true,
    key: 'active',
    i18n: 'STATUS_KEY',
    centerTitle: true,
  },
  {
    order: true,
    key: 'latest_access',
    i18n: 'LAST_LOGIN_DATE_KEY',
    centerTitle: true,
  },
  {
    key: '',
    i18n: 'ACTIONS_KEY',
    centerTitle: true,
  },
];
